"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileGames = void 0;
var MobileGames_1 = require("./MobileGames");
Object.defineProperty(exports, "MobileGames", { enumerable: true, get: function () { return __importDefault(MobileGames_1).default; } });
